module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAAAWlBMVEUAAAB8fHyKiop7e3t6enp7e3t7e3t7e3t7e3t7e3t6enp6enp6enp6enp7e3t9fX17e3t8fHx6enp7e3t6enp7e3t7e3t6enp8fHx7e3t7e3t9fX2AgIB6enrkz/rdAAAAHXRSTlMAbAi2eXTq2k/25bComGAY30j0z8KqnoyEfjYtEh4V3/0AAAB8SURBVBjTfdFZDsMgDATQMRTIvnRJt8z9r1kpwioSVt6X5Q+wx8jc5Je2u4cZhSay8+OQ2L4d1JO39Si+Pb22A0ctIexxmDngTyj5VYeCjw61DycY0gOrqB3ZlhCpBNnriuaShb3oGrbF/s2ezN6i3jhQTtKpk7RTty/0A5SBB6PhMR9QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/tuichuleft.png
// module id = 3145
// module chunks = 1